import React from 'react';

import {IconButton, TextField} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TabsDateStartEnd from "./containers/tabs/TabsDateStartEnd";
import moment from 'moment'
import ModalCustom from "@ui/modal/ModalCustom";
import {useMedia} from "@hooks/ui/useMedia";

const inputCustomSx = {
    borderColor: '#00000033',
    width: {
        xs: '160px',
        lg: '190px',
        fontSize:'10px'
    },

}

const DatePickerDateStartEnd = ({
                                    label,
                                    format,
                                    size,
                                    disabled,
                                    value,
                                    dateStart,
                                    dateEnd,
                                    onChangeDateStart,
                                    onChangeDateEnd,
                                    initialTab,
                                    hasTime = false,
                                }) => {

    const {isDesktop} = useMedia()
    return (
        <ModalCustom
            empty
            button={<TextField
                sx={{
                    ...inputCustomSx,
                    "& .MuiInputBase-root": {
                        paddingRight: {
                            xs: '0',
                            lg: '20px'
                        },
                       '.lightTheme &':{
                           background: disabled ? 'transparent' : '#fff',
                       }
                    },
                }}
                InputProps={{
                    endAdornment: isDesktop ? <InputAdornment position="end">
                        <IconButton
                            edge="end">
                            <CalendarMonthIcon/>
                        </IconButton>
                    </InputAdornment> : undefined,
                    readOnly: true
                }}
                size={'small'}
                value={moment(value, format)?.format(hasTime ? 'DD.MM.YYYY HH:mm' : 'DD.MM.yyy')}
                disabled={disabled}
                label={label}
            />}
            component={<TabsDateStartEnd
                dateStart={dateStart}
                onChangeDateStart={onChangeDateStart}
                dateEnd={dateEnd}
                onChangeDateEnd={onChangeDateEnd}
                format={format}
                label={label}
                initialTab={initialTab}
                hasTime={hasTime}
            />}
        />

    )
}

export default DatePickerDateStartEnd;